<template>
  <div>
    <ColescbaApp
      ref="colescba"
      class="print:hidden"
      environment-banner-classes="z-1000 md:z-5"
      mx-app-container-classes="auto mb-2 space-y-6 max-w-9xl"
      :app-routes="routes"
      :router-view-classes="routerViewClasses"
    >
      <div v-if="!$route.meta.fullScreen" class="mt-8" slot="before-router">
        <h4 class="mb-6 text-center text-3xl font-semibold text-gray-700">
          {{ $route.meta.title.text }}
        </h4>
      </div>
    </ColescbaApp>

    <div id="print-area" class="hidden print:block"></div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { useColescba, useProvideService } from '@colescba/app-vue'

import { PortalPagosService } from '@/services/portalPagos.service'

const requestedServices = [
  config =>
    useProvideService(config, 'portalPagos', PortalPagosService, {
      baseUrlEnvVar: 'VUE_APP_PORTAL_PAGOS_SERVICE_URL',
    }),
]

import { routes } from '@/config'

export default {
  mixins: [useColescba({ requestedServices, env: process.env })],

  data() {
    return {
      routes,
    }
  },

  computed: {
    routerViewClasses() {
      const fullScreenClasses = !this.$route.meta.fullScreen ? 'xl:w-5/6' : ''

      // return `container mx-auto rounded-md bg-white p-6 shadow-md  print:shadow-none ${fullScreenClasses}`
      return `container mx-auto print:shadow-none ${fullScreenClasses}`
    },
  },
}
</script>
